import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../components/LocalNotepad.css";

const API_BASE = "https://newerp.awasthivitality.com/api";

/* ================= Helpers ================= */

const getSessionToken = () =>
  (localStorage.getItem("session_token") ||
    localStorage.getItem("token") ||
    "").trim();

const appendToken = (url) => {
  const token = getSessionToken();
  if (!token) return url;
  try {
    const parsed = new URL(url);
    if (!parsed.searchParams.has("token")) {
      parsed.searchParams.append("token", token);
    }
    return parsed.toString();
  } catch {
    return url;
  }
};

const getAuthHeaders = () => {
  const token = getSessionToken();
  const headers = {
    "Content-Type": "application/json",
    Accept: "application/json",
  };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
    headers["X-Session-Token"] = token;
  }
  return headers;
};

/* ================= Component ================= */

const LocalNotepad = () => {
  const navigate = useNavigate();

  /* -------- State -------- */
  const [notes, setNotes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sortOrder, setSortOrder] = useState("asc");
const [timeSortOrder, setTimeSortOrder] = useState("asc");

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  /* -------- Date Color Logic -------- */
  // const getDateStyle = (dateStr) => {
  //   const today = new Date();
  //   today.setHours(0, 0, 0, 0);

  //   const noteDate = new Date(dateStr);
  //   noteDate.setHours(0, 0, 0, 0);

  //   // difference in days
  //   const diffTime = noteDate - today;
  //   const diffDays = Math.round(diffTime / (1000 * 60 * 60 * 24));

  //   // Past
  //   if (diffDays < 0) {
  //     return { color: "#dc3545", fontWeight: 600 }; // red
  //   }

  //   // Today
  //   if (diffDays === 0) {
  //     return { color: "#0d6efd", fontWeight: 700 }; // blue
  //   }

  //   // Tomorrow
  //   if (diffDays === 1) {
  //     return { color: "#fd7e14", fontWeight: 700 }; // orange
  //   }
  //   if (diffDays === 2) {
  //     return { color: "#57e8d3", fontWeight: 700 }; // orange
  //   }
  //   if (diffDays === 3) {
  //   return { color: "#fd14a0", fontWeight: 700 }; // orange
  // }
  // if (diffDays === 4) {
  //   return { color: "#14defd", fontWeight: 700 }; // orange
  // }
  // if (diffDays === 5) {
  //   return { color: "#6f9529", fontWeight: 700 }; // orange
  // }
  //   if (diffDays === 6) {
  //     return { color: "#e482d5", fontWeight: 700 }; // orange
  //   }
  //   if (diffDays === 7) {
  //     return { color: "#f7cd79", fontWeight: 700 }; // orange
  //   }
  //   if (diffDays === 8) {
  //     return { color: "#2eb090", fontWeight: 700 }; // orange
  //   }
  //   if (diffDays === 9) {
  //     return { color: "#4a0e0e", fontWeight: 700 }; // orange
  //   }
  //   if (diffDays === 10) {
  //     return { color: "#544ae6", fontWeight: 700 }; // orange
  //   }
  //   if (diffDays === 11) {
  //     return { color: "#a84ae6", fontWeight: 700 }; // orange
  //   }
  //   if (diffDays === 12) {
  //     return { color: "#4ae675", fontWeight: 700 }; // orange
  //   }
  //   if (diffDays === 13) {
  //     return { color: "#7a79cd", fontWeight: 700 }; // orange
  //   }
  //   if (diffDays === 14) {
  //     return { color: "#fd14d6", fontWeight: 700 }; // orange
  //   }
  //   if (diffDays === 15) {
  //     return { color: "#1d5865", fontWeight: 700 }; // orange
  //   }
  //   if (diffDays === 16) {
  //     return { color: "#e48282", fontWeight: 700 }; // orange
  //   }
  //   if (diffDays === 17) {
  //     return { color: "#d5e482", fontWeight: 700 }; // orange
  //   }
  //   if (diffDays === 18) {
  //     return { color: "#82d5e4", fontWeight: 700 }; // orange
  //   }
  //   if (diffDays === 19) {
  //     return { color: "#e482d5", fontWeight: 700 }; // orange
  //   }
  //   if (diffDays === 20) {
  //     return { color: "#f7cd79", fontWeight: 700 }; // orange
  //   }
  //   if (diffDays === 21) {
  //     return { color: "#14fdc4", fontWeight: 700 }; // orange
  //   }
  //   if (diffDays === 22) {
  //     return { color: "#4a0e0e", fontWeight: 700 }; // orange
  //   }
  //   if (diffDays === 23) {
  //     return { color: "#c74ae6", fontWeight: 700 }; // orange
  //   }
  //   if (diffDays === 24) {
  //     return { color: "#ad2170", fontWeight: 700 }; // orange
  //   }
  //   if (diffDays === 25) {
  //     return { color: "#4ae675", fontWeight: 700 }; // orange
  //   }
  //   if (diffDays === 26) {
  //     return { color: "#007109", fontWeight: 700 }; // orange
  //   }
  //   if (diffDays === 27) {
  //     return { color: "#c7fd14", fontWeight: 700 }; // orange
  //   }
  //   if (diffDays === 28) {
  //     return { color: "#899792", fontWeight: 700 }; // orange
  //   }
  //   if (diffDays === 29) {
  //     return { color: "#e48282", fontWeight: 700 }; // orange
  //   }
  //   if (diffDays === 30) {
  //     return { color: "#d5e482", fontWeight: 700 }; // orange
  //   }

  //   // More than 30 days
  //   return { color: "#6f42c1", fontWeight: 600 }; // purple
  // };
// const dateColors = [
//   "#0d6efd", // today
//   "#fd7e14",
//   "#57e8d3",
//   "#fd14a0",
//   "#14defd",
//   "#6f9529",
//   "#e482d5",
//   "#f7cd79",
//   "#2eb090",
//   "#4a0e0e",
//   "#544ae6",
//   "#a84ae6",
//   "#4ae675",
//   "#7a79cd",
//   "#fd14d6",
//   "#1d5865",
//   "#e48282",
//   "#d5e482",
//   "#82d5e4",
//   "#e482d5",
//   "#f7cd79",
//   "#14fdc4",
//   "#4a0e0e",
//   "#c74ae6",
//   "#ad2170",
//   "#4ae675",
//   "#007109",
//   "#c7fd14",
//   "#899792",
//   "#e48282",
//   "#d5e482",
// ];
// const getDateTheme = (dateStr) => {
//   const today = new Date();
//   today.setHours(0, 0, 0, 0);

//   const noteDate = new Date(dateStr);
//   noteDate.setHours(0, 0, 0, 0);

//   const diffDays = Math.round(
//     (noteDate - today) / (1000 * 60 * 60 * 24)
//   );

//   // Past dates
//   if (diffDays < 0) {
//     return {
//       dateText: { color: "#dc3545", fontWeight: 700 },
//       rowStyle: { backgroundColor: "#dc354522" },
//     };
//   }

//   // 0–30 days
//   if (diffDays <= 30) {
//     const color = dateColors[diffDays];
//     return {
//       dateText: { color, fontWeight: 700 },
//       rowStyle: { backgroundColor: `${color}22` },
//     };
//   }

//   // More than 30 days
//   return {
//     dateText: { color: "#6f42c1", fontWeight: 600 },
//     rowStyle: { backgroundColor: "#6f42c122" },
//   };
// };
const dateColors = [
  "#0d6efd", "#fd7e14", "#57e8d3", "#fd14a0", "#14defd",
  "#6f9529", "#e482d5", "#f7cd79", "#2eb090", "#4a0e0e",
  "#544ae6", "#a84ae6", "#4ae675", "#7a79cd", "#fd14d6",
  "#1d5865", "#e48282", "#d5e482", "#82d5e4", "#e482d5",
  "#f7cd79", "#14fdc4", "#4a0e0e", "#c74ae6", "#ad2170",
  "#4ae675", "#007109", "#c7fd14", "#899792", "#e48282",
  "#d5e482",
];

const getRowBgByDate = (dateStr) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const noteDate = new Date(dateStr);
  noteDate.setHours(0, 0, 0, 0);

  const diffDays = Math.round(
    (noteDate - today) / (1000 * 60 * 60 * 24)
  );

  // Past
  if (diffDays < 0) return { backgroundColor: "#f8d7da" };

  // Today → 30 days
  if (diffDays <= 30) {
    return { backgroundColor: `${dateColors[diffDays]}22` };
  }

  // Beyond 30 days
  return { backgroundColor: "#ede7f6" };
};


  /* -------- Fetch Notes -------- */
  const fetchNotes = async () => {
    try {
      setLoading(true);
      const response = await fetch(
        appendToken(`${API_BASE}/notes/show`),
        { headers: getAuthHeaders() }
      );
      const result = await response.json();

      if (result.success) {
        const formatted = result.data.map((note) => ({
          id: note.pdn_id,
          date: note.pdn_date,
          time: note.pdn_time || "",
          patient_name: note.patient_name || "",
          pdn_name: note.pdn_name || "",
          patient_id: note.patient_id || 0,
          comments: note.pdn_message,
          created_by: note.pdn_created_by,
        }));

        setNotes(formatted);
        setCurrentPage(1); // reset page
      } else {
        alert("Failed to fetch notes");
      }
    } catch (err) {
      console.error(err);
      alert("Error loading notes");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNotes();
  }, []);

  /* -------- Delete -------- */
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this note?")) return;

    try {
      const response = await fetch(
        appendToken(`${API_BASE}/notes/delete/${id}`),
        { method: "DELETE", headers: getAuthHeaders() }
      );
      const result = await response.json();
      if (result.success) {
        setNotes((prev) => prev.filter((note) => note.id !== id));
      }
    } catch {
      alert("Delete failed");
    }
  };

  /* -------- Sort -------- */
const sortedNotes = [...notes].sort((a, b) => {
  const dateA = new Date(`${a.date} ${a.time || "00:00"}`);
  const dateB = new Date(`${b.date} ${b.time || "00:00"}`);

  // First sort by date
  if (dateA.toDateString() !== dateB.toDateString()) {
    return sortOrder === "asc"
      ? dateA - dateB
      : dateB - dateA;
  }

  // If date is same → sort by time
  return timeSortOrder === "asc"
    ? dateA - dateB
    : dateB - dateA;
});
const formatToAMPM = (timeStr) => {
  if (!timeStr) return "-";

  // supports "HH:mm" or "HH:mm:ss"
  const [hour, minute] = timeStr.split(":");
  const h = parseInt(hour, 10);

  const ampm = h >= 12 ? "PM" : "AM";
  const hour12 = h % 12 || 12;

  return `${hour12}:${minute} ${ampm}`;
};


  /* -------- Pagination -------- */
  const totalPages = Math.ceil(sortedNotes.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedNotes = sortedNotes.slice(startIndex, endIndex);

  useEffect(() => {
    setCurrentPage(1);
  }, [sortOrder]);
useEffect(() => {
  setCurrentPage(1);
}, [timeSortOrder]);

  /* ================= UI ================= */

  return (
    <div className="notepad-container">
      {/* Header */}
      <div className="notepad-header">
        <h2>📒 Local Notepad Report</h2>
        <div className="actions">
          <button
            className="btn btn-add"
            onClick={() => navigate("/AddLocalNotepad")}
          >
            ➕ Add New Notepad
          </button>

          <button className="btn btn-refresh" onClick={fetchNotes}>
            ⟳ Refresh
          </button>
        </div>
      </div>

      {/* Table */}
      <div className="table-wrapper">
        <table className="note-table">
          <thead>
            <tr>
              <th>#</th>
              <th
                style={{ cursor: "pointer" }}
                onClick={() =>
                  setSortOrder(sortOrder === "asc" ? "desc" : "asc")
                }
              >
                Date {sortOrder === "asc" ? "↑" : "↓"}
              </th>
              {/* <th>Time</th> */}
              <th
  style={{ cursor: "pointer" }}
  onClick={() =>
    setTimeSortOrder(timeSortOrder === "asc" ? "desc" : "asc")
  }
>
  Time {timeSortOrder === "asc" ? "↑" : "↓"}
</th>

              <th>Patient Name</th>
              <th>New Patient Name</th>
              <th>Patient ID</th>
              <th>Comments</th>
              <th>Created By</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr><td colSpan="9" align="center">Loading...</td></tr>
            ) : paginatedNotes.length ? (
              paginatedNotes.map((note, index) => (
                // <tr key={note.id}>
//                 <tr
//   key={note.id}
//   style={getDateTheme(note.date).rowStyle}
// >
<tr key={note.id} style={getRowBgByDate(note.date)}>


                  <td data-label="#">{startIndex + index + 1}</td>
                  {/* <td data-label="Date" style={getDateStyle(note.date)}>{note.date}</td> */}
                  <td data-label="Date">{note.date}</td>

                  {/* <td data-label="Time">{note.time || "-"}</td> */}
                  <td data-label="Time">
  {formatToAMPM(note.time)}
</td>

                  <td data-label="Patient">{note.patient_name || "-"}</td>
                  <td data-label="New Patient">{note.pdn_name || "-"}</td>
                  <td data-label="Patient ID">
                    {note.patient_id > 0 ? (
                      <span
                        onClick={() => navigate(`/patient/details/${note.patient_id}`)}
                        style={{ color: "#007bff", cursor: "pointer", textDecoration: "underline" }}
                      >
                        {note.patient_id}
                      </span>
                    ) : "-"}
                  </td>
                  <td data-label="Comments">{note.comments || "-"}</td>
                  <td data-label="Created By">{note.created_by || "-"}</td>
                  <td data-label="Actions">
                    <div className="action-buttons">
                      <button
                        className="btn btn-edit"
                        onClick={() => navigate(`/EditLocalNotepad/${note.id}`)}
                      >
                        ✏️ Edit
                      </button>

                      <button
                        className="btn btn-delete"
                        onClick={() => handleDelete(note.id)}
                      >
                        🗑 Delete
                      </button>
                    </div>
                  </td>

                </tr>
              ))
            ) : (
              <tr><td colSpan="9" align="center">No records found</td></tr>
            )}
          </tbody>
        </table>

        {/* Pagination */}
        {totalPages > 1 && (
          <div className="pagination">
            <button
              className="btn"
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((p) => p - 1)}
            >
              ◀ Prev
            </button>

            {[...Array(totalPages)].map((_, i) => (
              <button
                key={i}
                className={`btn ${currentPage === i + 1 ? "btn-active" : ""
                  }`}
                onClick={() => setCurrentPage(i + 1)}
              >
                {i + 1}
              </button>
            ))}

            <button
              className="btn"
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage((p) => p + 1)}
            >
              Next ▶
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default LocalNotepad;
